import { MonitorSessionTable } from './MonitorSessionTable';
export default MonitorSessionTable;
